<template>
  <div>
    <div
      v-if="loading"
      class="ma-5 text-xs-center"
    >
      <v-progress-circular
        indeterminate
        :size="32"
        color="accent"
      />
    </div>
    <div
      v-else
      class="ma-3"
    >
      <div
        v-if="session.id"
        class="title pb-2"
      >
        {{ sessionTypeStrLong(session.session_type) }} session #<router-link
          class="black--text"
          :to="{name: 'sessions-show-info', params: {id: session.id}}"
        >
          {{ session.reference }}
        </router-link>
      </div>
      <router-link
        :to="{name: 'sessions-index'}"
        class="link-unstyled inline"
      >
        <v-icon
          color="primary"
          size="16"
        >
          mdi-arrow-left
        </v-icon>
        Back to the list
      </router-link>

      <div
        layout="row"
        class="mt-3"
      >
        <v-list class="sidebar">
          <template v-for="(v, k) in sidebarOptions">
            <v-list-tile
              v-if="!v.stop() && (!v.types || v.types.indexOf(session.session_type) >= 0) && (v.accessible_by_trainers() || isAdmin || isCoord)"
              :key="k"
              :to="{name: v.link, params: {id: $route.params.id}}"
            >
              <v-list-tile-avatar>
                <v-icon>{{ v.icon }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>
                {{ v.text }}
              </v-list-tile-title>
            </v-list-tile>
          </template>
        </v-list>
        <router-view
          v-if="session.id"
          class="mx-3"
          flex
          :is-admin="isAdmin"
          :is-coord="isCoord"
          :is-trainer="isTrainer"
          :session="session"
          @ask-session-refresh="askSessionRefresh"
        />
      </div>
    </div>
  </div>
</template>

<script>
    import Sessions from '@/api/sessions'
    import SessionsMixin from '@/mixins/sessions'
    import Auth from '@/plugins/auth'
    import Consts from '@/consts'
    import moment from 'moment';

    export default {
        mixins: [SessionsMixin],
        data () {
            return {
                sidebarOptions: [
                    { text: 'Daggestrapport', icon: 'mdi-account-group', link: 'sessions-show-daggesrapport-evals', stop: () => false, types: [Consts.SCHOOL, Consts.ADULTS, Consts.YOUTH, Consts.TEACHERS, Consts.OTHER, Consts.INTERNAL, Consts.FREELANCES_TRAINING, Consts.FREELANCES_REFRESH_TRAINING, Consts.INTRODUCTION_DAY, Consts.ACTIVITY], accessible_by_trainers: () => true },
                    { text: 'Trainer evaluations', icon: 'mdi-sticker-check-outline', link: 'sessions-show-trainer-evals', stop: this.hasNoTrainer, types: [Consts.SCHOOL, Consts.ADULTS, Consts.YOUTH, Consts.TEACHERS, Consts.OTHER, Consts.INTERNAL, Consts.FREELANCES_TRAINING, Consts.FREELANCES_REFRESH_TRAINING, Consts.INTRODUCTION_DAY, Consts.ACTIVITY], accessible_by_trainers: () => true },
                    { text: 'Teacher evaluations', icon: 'mdi-human-male-board', link: 'sessions-show-teacher-evals', stop: () => false, types: [Consts.SCHOOL], accessible_by_trainers: () => false },
                    { text: 'Interns evaluations', icon: 'mdi-account-file-text-outline', link: 'sessions-show-interns-evals', stop: this.hasNoVisitor, types: [Consts.ACTIVITY], accessible_by_trainers: this.trainerIsExpert },
                    { text: 'Review', icon: 'mdi-message-draw', link: 'sessions-edit-review', stop: () => false, types: [Consts.EVENTS], accessible_by_trainers: () => true }
                ],
                loading: true,
                session: {
                    organization_id: null,
                    organization: null,
                    contact_id: null,
                    contact: null,
                    contact2_id: null,
                    contact2: null,
                    session_type: 0,
                    dates: [],
                    users_groups: [],
                    events_settings: [],
                    activities: []
                },
                isTrainer: false,
                isCoord: false,
                isAdmin: false,
            }
        },

        mounted() {
            if (this.$route.params.id === 'new') {
                const queryType = parseInt(this.$route.query.type);

                if (queryType <= 0 || queryType > 6 || isNaN(queryType)) {
                    this.$router.replace({name: 'sessions-index'});
                } else {
                    this.session.session_type = this.$route.query.type;
                }
            } else {
                this.askSessionRefresh()
            }
            this.loadUser();
        },
        methods: {
          askSessionRefresh() {
            this.loading = true;
            Sessions.get(this.$route.params.id).then(res => {
                this.session = res.data;

                let hasEval = false
                this.sidebarOptions.forEach(v => {
                  if(!v.stop() && (!v.types || v.types.indexOf(this.session.session_type) >= 0) && (v.accessible_by_trainers() || this.isAdmin || this.isCoord)){
                    hasEval = true
                  }
                })

                if(!hasEval){
                  this.$snotify.error('This session doesn\'t need any evaluation')
                  this.$router.push({name: 'sessions-show-info', params: {id: this.session.id}})
                }

                this.loading = false;

                if (this.session.dates.length > 0) {
                    // Parse dates into split date/time
                    for (let i = 0; i < this.session.dates.length; ++i) {
                        let d = this.session.dates[i];

                        d.date_start = moment(d.start).format('YYYY-MM-DD');
                        d.date_start_text = moment(d.start).format('YYYY-MM-DD');
                        d.clock_start = moment(d.start).format('HH:mm:ss');
                        d.clock_start_text = moment(d.start).format('HH:mm');
                        d.clock_end = moment(d.end).format('HH:mm:ss');
                        d.clock_end_text = moment(d.end).format('HH:mm');

                        this.session.dates[i] = d;
                    }
                }
            }, () => {
                this.$router.push({name: 'sessions-index'})
            })
          },
          trainerIsExpert() {
            return Auth.user.role == Consts.TRAINER && this.session.session_visitor.find(v => v.trainer_id == Auth.user.id)
          },
          hasNoVisitor() {
            return ! (this.session && this.session.session_visitor && this.session.session_visitor.length > 0)
          },
          hasNoTrainer() {
            let has = false

            if(this.session && this.session.trainers && this.session.trainers.length){
              this.session.trainers.forEach(u => {
                if(u.role == Consts.TRAINER){
                  has = true
                }
              })
            }

            return !has
          },
          loadUser(){
            if(Auth.user.is_admin){
              this.isAdmin = true;
            }
            if(Auth.user.role == Consts.COORDINATION){
              this.isCoord = true;
            }
            if(Auth.user.role == Consts.TRAINER){
              this.isTrainer = true;
            }
          }
        }
    }
</script>

<style scoped>
.sidebar {
  border-right: 1px solid #ddd;
  width: 250px;
  background: transparent;
}
.inline {
  display: inline;
}
</style>
